import type { Tool, FilterCategory } from "@/types/tool";
import ToolCard from "./ToolCard";

interface ToolsGridProps {
  tools: Tool[];
  filter: FilterCategory;
  selectedIds: string[];
  onToggleSelect: (id: string) => void;
  promotedToolIds?: string[];
}

const ToolsGrid = ({ tools, filter, selectedIds, onToggleSelect, promotedToolIds = [] }: ToolsGridProps) => {
  const filteredTools = tools.filter((tool) => 
    filter === "all" ? true : tool.category === filter
  );

  // Sort promoted tools first
  const sortedTools = [...filteredTools].sort((a, b) => {
    const aPromoted = promotedToolIds.includes(a.id);
    const bPromoted = promotedToolIds.includes(b.id);
    if (aPromoted && !bPromoted) return -1;
    if (!aPromoted && bPromoted) return 1;
    return 0;
  });

  return (
    <div className="flex flex-col gap-4 max-w-4xl mx-auto">
      {sortedTools.map((tool, index) => (
        <div key={tool.id} id={`tool-card-${tool.id}`} className="min-h-0 scroll-mt-[220px] animate-fade-in" style={{ animationDelay: `${Math.min(index * 30, 150)}ms` }}>
          <ToolCard
            tool={tool}
            isSelected={selectedIds.includes(tool.id)}
            onToggleSelect={onToggleSelect}
            index={index}
            isPromoted={promotedToolIds.includes(tool.id)}
          />
        </div>
      ))}
    </div>
  );
};

export default ToolsGrid;
